export const inspectTable_1 = [
  {
    title: "1) 지반상태",
    content: "시설물 주변의 지반 침하 또는 이로 인한 건물의 기움, 균열 등",
    isChecked: "",
  },
  {
    title: "2) 구조부재",
    content: "주요 구조부재(보, 기둥, 슬래브, 내력벽)에 균열, 누수 및 누수흔적",
    isChecked: "",
  },
  {
    title: "2) 구조부재",
    content: "구조부재의 처짐, 기욺 또는 단면 손실 등의 변형",
    isChecked: "",
  },
  {
    title: "2) 구조부재",
    content: "철근 부식, 노출 또는 콘크리트의 박리·박락",
    isChecked: "",
  },
  {
    title: "2) 구조부재",
    content: "철골부재의 기욺, 좌굴 등의 변형",
    isChecked: "",
  },
  {
    title: "2) 구조부재",
    content: "철골부재 부식에 의한 단면 결손",
    isChecked: "",
  },
  {
    title: "3) 비구조부재",
    subTitle: "내부",
    content: "내부 칸막이벽(벽돌, 블록 등)에 균열 및 변형(기욺)",
    isChecked: "",
  },
  {
    title: "3) 비구조부재",
    subTitle: "내부",
    content: "천장, 벽체 및 바닥 마감재에 파손, 오염, 변형(처짐, 기욺 등), 누수 및 누수흔적",
    isChecked: "",
  },
  {
    title: "3) 비구조부재",
    subTitle: "외부",
    content: "옥상, 지붕 방수층의 상태",
    isChecked: "",
  },
  {
    title: "3) 비구조부재",
    subTitle: "외부",
    content: "옥상 난간의 과도한 균열, 변형 발생 및 난간 높이(1.2m 이상)",
    isChecked: "",
  },
  {
    title: "3) 비구조부재",
    subTitle: "외부",
    content: "지붕 마감재나 외벽재가 바람에 의한 비산의 위험성 여부",
    isChecked: "",
  },
  {
    title: "3) 비구조부재",
    subTitle: "외부",
    content: "외벽에 부착되어 있는 기기의 탈락·낙하의 위험성 여부",
    isChecked: "",
  },
  {
    title: "3) 비구조부재",
    subTitle: "외부",
    content: "균열이 있는 유리가 폭설에 의해 파손될 위험성 여부",
    isChecked: "",
  },
  {
    title: "4) 부대토목시설",
    subTitle: "콘크리트옹벽",
    content: "옹벽 파손 및 손상, 균열 발생 여부",
    isChecked: "",
  },
  {
    title: "4) 부대토목시설",
    subTitle: "콘크리트옹벽",
    content: "배면토의 침하, 침수, 배수구 막힘 발생 여부",
    isChecked: "",
  },
  {
    title: "4) 부대토목시설",
    subTitle: "콘크리트옹벽",
    content: "누수, 층 분리 및 박락, 백태 발생 여부",
    isChecked: "",
  },
  {
    title: "4) 부대토목시설",
    subTitle: "콘크리트옹벽",
    content: "철근 노출 발생 여부",
    isChecked: "",
  },
  {
    title: "4) 부대토목시설",
    subTitle: "콘크리트옹벽",
    content: "옹벽상단 토사 및 낙석제거 여부",
    isChecked: "",
  },
  {
    title: "4) 부대토목시설",
    subTitle: "보강토 옹벽 및 석축",
    content: "파손 및 손상, 균열, 누수 발생 여부",
    isChecked: "",
  },
  {
    title: "4) 부대토목시설",
    subTitle: "보강토 옹벽 및 석축",
    content: "수평이동, 침하, 기울어짐 등 발생 여부",
    isChecked: "",
  },
  {
    title: "4) 부대토목시설",
    subTitle: "보강토 옹벽 및 석축",
    content: "변형(배부름 등) 발생 여부",
    isChecked: "",
  },
  {
    title: "4) 부대토목시설",
    subTitle: "보강토 옹벽 및 석축",
    content: "배면토의 침하, 침수 여부",
    isChecked: "",
  },
  {
    title: "4) 부대토목시설",
    subTitle: "보강토 옹벽 및 석축",
    content: "배수구 설치 및 청소 여부",
    isChecked: "",
  },
  {
    title: "4) 부대토목시설",
    subTitle: "보강토 옹벽 및 석축",
    content: "옹벽 및 석축 상단 토사 및 낙석제거 여부",
    isChecked: "",
  },
  {
    title: "4) 부대토목시설",
    subTitle: "게비온 옹벽",
    content: "채움재 유실 여부",
    isChecked: "",
  },
  {
    title: "4) 부대토목시설",
    subTitle: "게비온 옹벽",
    content: "와이어 메쉬(wire mesh)의 파손 여부",
    isChecked: "",
  },
  {
    title: "5) 주변시설",
    content: "주변시설(배수로,측구)의 설치 여부",
    isChecked: "",
  },
  {
    title: "5) 주변시설",
    content: "주변 배수시설의 관리 상태",
    isChecked: "",
  },
  {
    title: "5) 주변시설",
    content: "배수시설의 배수기능 적합 여부",
    isChecked: "",
  },
  {
    title: "5) 주변시설",
    content: "도로융기 발생 여부(도로시설)",
    isChecked: "",
  },
  {
    title: "5) 주변시설",
    content: "인접 가로수의 일률적 기울어짐 여부",
    isChecked: "",
  },
  {
    title: "5) 주변시설",
    content: "침하의 발생 여부(상부지반)",
    isChecked: "",
  },
  {
    title: "5) 주변시설",
    content: "주변 시설 변형 여부",
    isChecked: "",
  },
  {
    title: "5) 주변시설",
    content: "인접 지중 매설관의 누수 여부",
    isChecked: "",
  },
  {
    title: "5) 주변시설",
    content: "상·하수시설물 파손 여부",
    isChecked: "",
  },
];

export const inspectTable_2 = [
  {
    title: "1) 바닥부",
    subTitle: "철도",
    content: "배수 및 배수구 상태",
    isChecked: "",
  },
  {
    title: "1) 바닥부",
    subTitle: "철도",
    content: "도상부 분리 및 균열 등<br/><span style='font-weight: normal;'>- 분리면 범위 및 균열 진행성</span><br/><span style='font-weight: normal;'>- 신규 균열 발생 여부</span>",
    isChecked: "",
  },
  {
    title: "1) 바닥부",
    subTitle: "철도",
    content: "침목의 균열 발생 및 파손",
    isChecked: "",
  },
  {
    title: "1) 바닥부",
    subTitle: "도로",
    content: "포장부 파손",
    isChecked: "",
  },
  {
    title: "1) 바닥부",
    subTitle: "도로",
    content: "배수 및 배수구 상태",
    isChecked: "",
  },
  {
    title: "2) 본선 라이닝 점검",
    content: "라이닝 콘크리트 균열 및 누수<br/><span style='font-weight: normal;'>- 파손 및 손상</span><br/><span style='font-weight: normal;'>- 균열 진행성(폭, 길이)</span><br/><span style='font-weight: normal;'>- 누수범위 상태<span></span><br/><span style='font-weight: normal;'>- 재질열화(박리, 박락, 백태, 철근노출 등)</span>",
    isChecked: "",
  },
  {
    title: "2) 본선 라이닝 점검",
    content: "시공이음부 및 타일부 누수 및 들뜸<br/><span style='font-weight: normal;'>- 시공이음부 및 타일부 들뜸 범위 등</span><br/><span style='font-weight: normal;'>- 지하수 용출 및 토사유출 상태</span>",
    isChecked: "",
  },
  {
    title: "2) 본선 라이닝 점검",
    content: "개착구간 라이닝 상태(균열, 누수)",
    isChecked: "",
  },
  {
    title: "3) 주변지형 및 기타",
    content: "터널 상부 지형변화 여부",
    isChecked: "",
  },
  {
    title: "3) 주변지형 및 기타",
    content: "터널 주변 굴착공사 여부",
    isChecked: "",
  },
  {
    title: "3) 주변지형 및 기타",
    content: "갱구부 비탈면 및 옹벽 상태",
    isChecked: "",
  },
  {
    title: "3) 주변지형 및 기타",
    content: "갱문 상부 배수로 상태 및 기타",
    isChecked: "",
  },
];

export const inspectTable_3 = [
  {
    title: "1) 상부구조 상면(교면, 배수, 난간 및 연석, 신축이음)",
    content: "교면포장(아스콘, 콘크리트) 손상<br/><span style='font-weight: normal;'>- 균열, 소성변형, 요철, 함몰, 체수, 낙수로 인한 결빙</span>",
    isChecked: "",
  },
  {
    title: "1) 상부구조 상면(교면, 배수, 난간 및 연석, 신축이음)",
    content: "배수시설(배수구, 배수관)<br/><span style='font-weight: normal;'>- 파손(Grating, 관), 체수, 막힘</span>",
    isChecked: "",
  },
  {
    title: "1) 상부구조 상면(교면, 배수, 난간 및 연석, 신축이음)",
    content: "난간 및 연석<br/><span style='font-weight: normal;'>- 난간 파손, 부식</span><br/><span style='font-weight: normal;'>- 연석 파손, 박리(염해, 동결융해)</span>",
    isChecked: "",
  },
  {
    title: "1) 상부구조 상면(교면, 배수, 난간 및 연석, 신축이음)",
    content: "신축이음<br/><span style='font-weight: normal;'>- 본체 변형, 씰링 파손, 누수, 이상음</span><br/><span style='font-weight: normal;'>- 후타재 파손, 박리(해빙기 – 동결융해, 염해)</span>",
    isChecked: "",
  },
  {
    title: "1) 상부구조 상면(교면, 배수, 난간 및 연석, 신축이음)",
    content: "포장부 파손",
    isChecked: "",
  },
  {
    title: "1) 상부구조 상면(교면, 배수, 난간 및 연석, 신축이음)",
    content: "배수 및 배수구 상태",
    isChecked: "",
  },
  {
    title: "2) 상부구조 하면(바닥판, 거더, 받침)",
    content: `바닥판(강바닥판, RC)<br/>
<span style='font-weight: normal;'>- 균열, 누수(방수층 손상), 백태</span><br/>
<span style='font-weight: normal;'>- 도장 손상 및 부식, 체수</span><br/>
<span style='font-weight: normal;'>- 강바닥판 변형, RC 철근노출</span>`,
    isChecked: "",
  },
  {
    title: "2) 상부구조 하면(바닥판, 거더, 받침)",
    content: `거더(박스, 플레이트)<br/>
<span style='font-weight: normal;'>- 강박스 내부 우수유입 및 체수 (지점부)</span><br/>
<span style='font-weight: normal;'>- 2차부재 변형, 연결부 상태</span><br/>
<span style='font-weight: normal;'>- 도장 손상 및 부식</span><br/>
<span style='font-weight: normal;'>- 콘크리트 박스 균열, 누수, 백태</span>`,
    isChecked: "",
  },
  {
    title: "2) 상부구조 하면(바닥판, 거더, 받침)",
    content: `받침(강재, 탄성)<br/>
<span style='font-weight: normal;'>- 교좌장치 이동 여유량 확보, 가동불량, 앵커볼트 파손</span><br/>
<span style='font-weight: normal;'>- 거더와 받침연결부 부식, 신축이음 하부 우수유입</span><br/>
<span style='font-weight: normal;'>- 받침모르타르 균열, 파손(동결융해)</span>`,
    isChecked: "",
  },
  {
    title: "3) 하부구조(교대, 교각, 기초)",
    content: `교대<br/>
<span style='font-weight: normal;'>- 흉벽 기울기 이상(측방유동), 토사유실</span><br/>
<span style='font-weight: normal;'>- 균열, 신축이음 누수, 백태</span>`,
    isChecked: "",
  },
  {
    title: "3) 하부구조(교대, 교각, 기초)",
    content: `교각<br/>
<span style='font-weight: normal;'>- 침하(부등침하), 기울기 이상</span><br/>
<span style='font-weight: normal;'>- 균열, 누수, 백태</span>`,
    isChecked: "",
  },
  {
    title: "3) 하부구조(교대, 교각, 기초)",
    content: `기초<br/>
<span style='font-weight: normal;'>- 세굴(직접기초 및 말뚝 노출), 침식</span>`,
    isChecked: "",
  },
];

// export const inspectTable_1 = [
//   {
//     id: 1,
//     label: "작업 시작 전 작업장소 및 주변의 부석·균열 유무, 함수·용수와 동결상태의  변화를 점검한다. ",
//     is_checked: "",
//   },
//   {
//     id: 2,
//     label: "사전에 지하매설물(상·하수도 관로 및 도시가스관 등) 및 지상 지장물(전신주 및 가공전선로 등)을 모두 이설 또는 방호 조치한다. ",
//     is_checked: "",
//   },
//   {
//     id: 3,
//     label: "굴착면의 높이가 2미터 이상인 경우 토질 상태를 사전조사 하고 그 결과를  고려하여 작업계획서를 작성한다. ",
//     is_checked: "",
//   },
//   {
//     id: 4,
//     label: "굴착사면 또는 흙막이지보공 붕괴위험에 대해 굴착 작업 전·진행 중 수시  확인하고 그 위험성을 즉시 제거한다. ",
//     is_checked: "",
//   },
//   {
//     id: 5,
//     label: "흙막이 붕괴방지를 위해 필요한 계측을 실시하고 이상변위 시 즉시 조치한다.",
//     is_checked: "",
//   },
//   {
//     id: 6,
//     label: "과굴착 하지 않도록 사전 굴착계획에 따라 작업을 진행하고 토류판을 적기에 설치한다.",
//     is_checked: "",
//   },
//   {
//     id: 7,
//     label: "토사반출 작업을 위한 복공판 설치 등 충분한 작업공간을 확보하고 차량계건설기계 등이 안전하게 운행·작업 하도록 한다. ",
//     is_checked: "",
//   },
//   {
//     id: 8,
//     label: "흙막이 지보공 조립 시 버팀대, 띠장 등 상부에 추락방지용 안전시설을 반드시 설치한다.",
//     is_checked: "",
//   },
//   {
//     id: 9,
//     label: "근로자가 지하 굴착작업 장소까지 이동할 수 있도록 가설계단 등 안전한통로를 확보하여야 한다.",
//     is_checked: "",
//   },
//   {
//     id: 10,
//     label: "클램쉘 등으로 굴착 토사 운반 시 신호수를 배치하고 하부에 작업자가 출입하지 않토록 통제한다.",
//     is_checked: "",
//   },
//   {
//     id: 11,
//     label: "트렌치 굴착 시에는 작업 여건, 위험도 등에 따라 간이 흙막이를 설치하거나 굴착면의 안전 기울기를 확보하여야 한다.",
//     is_checked: "",
//   },
// ];
// export const inspectTable_2 = [
//   {
//     id: 1,
//     label: "거푸집동바리 구조 검토를 실시하고 조립도를 작성하여야 한다. ",
//     is_checked: "",
//   },
//   {
//     id: 2,
//     label: "거푸집동바리 조립도(동바리, 수평연결재, 가새재 위치 등)에 따라  조립하여야 한다.",
//     is_checked: "",
//   },
//   {
//     id: 3,
//     label: "거푸집·동바리 조립 시 상부에 자재 과적으로 인한 붕괴위험이 없도록  조치한다. ",
//     is_checked: "",
//   },
//   {
//     id: 4,
//     label: "작업자에게 적정한 개인보호구(안전모, 안전대 등)를 지급하고  추락 등 위험 시 반드시 안전대를 걸고 작업하여야 한다. ",
//     is_checked: "",
//   },
//   {
//     id: 5,
//     label: "거푸집 설치-해체-인양작업 시 안전조치 사항에 대해 작업자가 충분히  숙지하도록 특별안전교육을 실시한다.",
//     is_checked: "",
//   },
//   {
//     id: 6,
//     label: "슬래브 단부, 개구부 등의 추락방호조치는 적절하게 실시하여야 한다.",
//     is_checked: "",
//   },
//   {
//     id: 7,
//     label: "철근조립 등 고소 작업을 위한 작업발판은 작업장소·위치 등을 고려하여  적정하게 사용하여야 한다. ",
//     is_checked: "",
//   },
//   {
//     id: 8,
//     label: "고소작업대 사용 시 발 스위치 연동장치, 조작레버 덮개 등의 안전장치 설치와 장비제원, 운전원 실명 등을 부착·관리한다.",
//     is_checked: "",
//   },
//   {
//     id: 9,
//     label: "콘크리트 펌프카는 아웃트리거를 최대한 인출하고 작업계획서에 따라 관계자외 출입금지, 타설순서 등을 준수하여야 한다.",
//     is_checked: "",
//   },
//   {
//     id: 10,
//     label: "클램쉘 등으로 콘크리트 양생(갈탄, 열풍기 보온양생) 시 산소·유해가스농도를 수시로 측정하고 출입자는 호흡용 보호구를 반드시 착용한다.굴착 토사 운반 시 신호수를 배치하고 하부에 작업자가출입하지 않토록 통제한다.",
//     is_checked: "",
//   },
// ];
// export const inspectTable_3 = [
//   {
//     id: 1,
//     label: "자재(벽돌, 블록, 시멘트, 모래, 물 등)는 작업에 필요한 수량만큼 수시로 안전하게 운반하여 사용한다. ",
//     is_checked: "",
//   },
//   {
//     id: 2,
//     label: "자재 운반 시 다른 작업에 방해되지 않도록 충분한 공간을 확보하고  운반용기계·기구 필요 시 안전성을 검토하여 사용하여야 한다.",
//     is_checked: "",
//   },
//   {
//     id: 3,
//     label: "내부 마감공사용 이동식비계, 말비계 등의 작업발판은 충분한 안전성을  확보하도록 설치하고 필요한 안전조치를 한다.",
//     is_checked: "",
//   },
//   {
//     id: 4,
//     label: "작업장 주변과 근로자 이동통로 상의 개구부에는 방호조치 및 안전표지를 부착하여야 한다.",
//     is_checked: "",
//   },
//   {
//     id: 5,
//     label: "작업자에게 적절한 개인보호구를 지급하고 올바르게 착용하도록 하여야 한다.",
//     is_checked: "",
//   },
//   {
//     id: 6,
//     label: "작업 장소로 이동하기 위한 안전한 통로를 확보하여야 한다.",
//     is_checked: "",
//   },
//   {
//     id: 7,
//     label: "천장 마감재 상부 에어컨 설치 등의 작업은 마감재 설치 전에 완료하고 마감재위로 작업자가 올라가지 않도록 한다.",
//     is_checked: "",
//   },
//   {
//     id: 8,
//     label: "정화조, 저수조 등 밀폐된 공간 내에서 방수 작업 시 질식위험을 제거하여야 한다.",
//     is_checked: "",
//   },
//   {
//     id: 9,
//     label: "벽체·천장 작업용 내부 비계 설치 시에는 사전에 조립도를 작성하고 필요한 안전조치 및 작업자 이동통로를 확보한다.",
//     is_checked: "",
//   },
//   {
//     id: 10,
//     label: "방수제 등 사용하는 화학물질에 대한 경고표시를 부착하고, 각 물질에 대한 MSDS를 작업자에게 교육한다.",
//     is_checked: "",
//   },
// ];
// export const inspectTable_4 = [
//   {
//     id: 1,
//     label: "외부비계 상 벽돌 등 자재는 필요한 수량만큼 적재하여 비계기둥 간의 적재하중은 400kg을 초과하지 않도록 한다.",
//     is_checked: "",
//   },
//   {
//     id: 2,
//     label: "외부 비계 상 근로자 승강통로는 작업자가 이용하기 쉽도록 충분한 수량을 설치하여야 한다.",
//     is_checked: "",
//   },
//   {
//     id: 3,
//     label: "외벽과 비계 사이에는 높이 10미터 이내마다 추락방호망을 설치하고 작업에 간섭이 되지 않는 한 안전시설을 해체하지 않는다. ",
//     is_checked: "",
//   },
//   {
//     id: 4,
//     label: "단열재 등 가연성 물질 주변에서 용접 작업 시 불티 비산방지 등 화재예방조치를 반드시 하여야 한다.",
//     is_checked: "",
//   },
//   {
//     id: 5,
//     label: "달비계 작업 전 로프 등 자재를 점검하고 달비계 로프 설치 시 작업자가 안전대를 부착하도록 관리감독을 확실히 한다. ",
//     is_checked: "",
//   },
//   {
//     id: 6,
//     label: "달비계 작업용 섬유로프 및 구명줄은 절단·마모 보호를 위해 보호덮개를  설치해야하며, 견고한 고정점에 결속하여야 한다.",
//     is_checked: "",
//   },
//   {
//     id: 7,
//     label: "석재 운반용 윈치 사용 시 고정부위가 안전한지 검토하고 줄걸이 방법 등을사전에 확인하여 안전하게 작업하여야 한다.",
//     is_checked: "",
//   },
//   {
//     id: 8,
//     label: "외부마감 작업 장소로 작업자가 안전하게 이동하기 위한 통로를 확보하여야 한다.",
//     is_checked: "",
//   },
//   {
//     id: 9,
//     label: "비계 조립 작업 시 주변에 특고압 전선 유무를 사전 확인하여 안전한 작업방법을 검토하고 벽이음 등을 간격에 맞춰 설치한다.",
//     is_checked: "",
//   },
//   {
//     id: 10,
//     label: "차량탑재형 고소작업대 사용 시 아웃트리거를 최대한 인출하고 탑승자는반드시 안전대를 부착한다.",
//     is_checked: "",
//   },
// ];
// export const inspectTable_5 = [
//   {
//     id: 1,
//     label: "강도가 약해 깨지기 쉬운 지붕 위에서 작업 시 반드시 30센티미터 이상의  작업발판을 설치해야 한다. ",
//     is_checked: "",
//   },
//   {
//     id: 2,
//     label: "채광창이 있는 경우 견고한 덮개를 설치해야 한다. ",
//     is_checked: "",
//   },
//   {
//     id: 3,
//     label: "지붕 가장자리에는 안전난간을 설치해야 하며, 곤란한 경우 추락 방호망을 설치하거나 안전대를 착용해야 한다. ",
//     is_checked: "",
//   },
//   {
//     id: 4,
//     label: "지붕의 형태, 구조 등을 사전 파악하여 적절한 이동통로, 작업발판설치 등  추락방지 조치를 하여야 한다.",
//     is_checked: "",
//   },
//   {
//     id: 5,
//     label: "지붕진입을 위한 승강설비(고정식 사다리, 워킹타워 등)를 적정하게 설치한다.",
//     is_checked: "",
//   },
//   {
//     id: 6,
//     label: "지붕 위에 자재를 집중 또는 과적하지 않도록 한다.",
//     is_checked: "",
//   },
//   {
//     id: 7,
//     label: "슬레이트, 채광창(skyligt) 지붕의 노후상태를 확인하고, 취약한 지붕재(슬레이트, 채광창 등)에 적절한 추락방호조치(발판, 안전덮개, 추락방지망, 안전대 착용 등 안전조치)를 하여야 한다.",
//     is_checked: "",
//   },
//   {
//     id: 8,
//     label: "지붕 단부에 추락방호조치(안전난간, 추락방지망, 안전대 착용 등 안전조치)를 하여야 한다. ",
//     is_checked: "",
//   },
//   {
//     id: 9,
//     label: "지붕 위 작업 시 가공전선에 접촉위험이 없도록 한다. ",
//     is_checked: "",
//   },
//   {
//     id: 10,
//     label: "작업 전 기상 및 지붕표면 상태를 확인하여 전도위험 등이 있는 경우 작업을 중지한다. ",
//     is_checked: "",
//   },
// ];
